/**
 * Store: Dynamic yield
 * -----------------------------------------------------------------------------
 * Handles Dynamic Yield campaigns and loaded state.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    campaigns: {},
    loaded: {},
    tests: [],
  }),

  mutations: {

    /**
     * Set loaded.
     * @param {String} target - Target
     */
    SET_LOADED(state, target) {
      state.loaded[target] = true
    },

    /**
     * Set campaign.
     * @param {Object} campaign - Campaign
     */
    SET_CAMPAIGN(state, campaign) {
      state.campaigns[campaign.target] = campaign
    },

    /**
     * Set test.
     * @param {String} test - Test name.
     */
    SET_TEST(state, test) {
      if (state.tests.includes(test)) {
        return
      }

      state.tests.push(test)
    },
  },

  actions: {

    /**
     * Commit loaded.
     * @param {String} target - Target
     */
    setLoaded({ commit }, target) {
      commit('SET_LOADED', target)
    },

    /**
     * Commit campaign.
     * @param {Object} campaign - Campaign.
     */
    setCampaign({ commit }, campaign) {
      commit('SET_CAMPAIGN', campaign)
    },

    /**
     * Commit tests.
     * @param {String} test - Test name.
     */
    setTest({ commit }, test) {
      commit('SET_TEST', test)
    },
  },
}
